import React from 'react'
import { Link } from 'react-router-dom'
import { companyInfo } from '../data/companyInfo'

const termsSections = [
    {
        title: 'Booking Confirmation',
        paragraphs: [
            `${companyInfo.name} confirms a booking only after package details, travel dates, and the required advance payment are agreed by both sides.`,
            'Package availability, hotel category, vehicle type, and final route timing remain subject to season, weather, and operational confirmation at the time of booking.'
        ]
    },
    {
        title: 'Payments',
        paragraphs: [
            'Advance payment is required to secure transport, accommodation, and operational arrangements. Remaining payment terms are shared before tour departure.',
            'Quoted rates may vary if the traveler changes route, hotel category, group size, or service scope after initial confirmation.'
        ]
    },
    {
        title: 'Cancellations & Changes',
        paragraphs: [
            'Cancellation charges depend on the stage of booking and any vendor commitments already made for hotels, transport, or other third-party services.',
            'Date changes and route revisions are handled subject to availability and may result in revised pricing depending on the season and service changes.'
        ]
    },
    {
        title: 'Weather & Route Conditions',
        paragraphs: [
            'Northern areas are subject to weather changes, landslides, road closures, and flight schedule disruptions. Safety remains the first priority in all operational decisions.',
            `${companyInfo.name} may adjust the itinerary, stopovers, or timing when required for traveler safety or route feasibility.`
        ]
    },
    {
        title: 'Traveler Responsibility',
        paragraphs: [
            'Travelers are responsible for providing correct personal details, communicating medical or mobility concerns in advance, and following guide or driver safety instructions during the trip.',
            'Personal belongings, travel insurance, and individual expenses not listed in the package remain the travelerâ€™s responsibility unless explicitly included in writing.'
        ]
    },
    {
        title: 'Service Scope',
        paragraphs: [
            'Included and excluded items vary by package and are confirmed at the time of booking. Any special request should be clearly discussed before confirmation.',
            'Images, route examples, and promotional descriptions are for planning reference. Final service delivery depends on package type, timing, and operational conditions.'
        ]
    }
]

function TermsConditionsContent() {
    return (
        <section className="space-top space-extra-bottom">
            <div className="container shape-mockup-wrap">
                <div className="row justify-content-center">
                    <div className="col-xl-8">
                        <div className="title-area text-center">
                            <span className="sub-title">Booking Policy</span>
                            <h2 className="sec-title">Terms &amp; Conditions</h2>
                            <p>
                                Please review these terms before confirming your tour or travel service with {companyInfo.name}.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="row gy-4">
                    <div className="col-lg-8">
                        <div className="page-single">
                            <div className="page-content d-block">
                                {termsSections.map((section) => (
                                    <div key={section.title} className="mb-40">
                                        <h3 className="box-title">{section.title}</h3>
                                        {section.paragraphs.map((paragraph, index) => (
                                            <p className="box-text mb-20" key={index}>
                                                {paragraph}
                                            </p>
                                        ))}
                                    </div>
                                ))}

                                <div className="destination-checklist mt-50">
                                    <div className="checklist style2 style4">
                                        <ul>
                                            <li>Advance payment required for confirmation</li>
                                            <li>Final rates depend on confirmed services</li>
                                            <li>Weather-related itinerary changes may apply</li>
                                            <li>Safety instructions must be followed on route</li>
                                        </ul>
                                    </div>
                                    <div className="checklist style5">
                                        <ul>
                                            <li>Personal expenses are not included unless confirmed</li>
                                            <li>Insurance is recommended for all travelers</li>
                                            <li>Last-minute changes may affect package cost</li>
                                            <li>Third-party vendor availability can affect operations</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4">
                        <aside className="sidebar-area">
                            <div className="widget widget_offer" style={{ background: 'url(/assets/img/bg/widget_bg_1.jpg)' }}>
                                <div className="offer-banner">
                                    <div className="offer">
                                        <h6 className="box-title">Need clarification before booking?</h6>
                                        <div className="banner-logo">
                                            <img src="/assets/img/primary-logo.png" alt="Himolan Peak Adventures" />
                                        </div>
                                        <div className="offer">
                                            <h6 className="offer-title">Contact {companyInfo.contactPerson}</h6>
                                            <Link className="offter-num" to={`tel:${companyInfo.phoneDial}`}>
                                                {companyInfo.phoneDisplay}
                                            </Link>
                                        </div>
                                        <p className="box-text text-white mb-20">{companyInfo.email}</p>
                                        <Link to="https://wa.me/03479020168?text=Assalam%20o%20Alaikum%21%20I%20want%20to%20book%20a%20tour%20with%20Himolan%20Peak%20Adventures." className="th-btn style2 th-icon">
                                            Contact Us
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            <div className="widget widget_categories">
                                <h3 className="widget_title">Quick Notes</h3>
                                <ul>
                                    <li>
                                        <Link to="/faq">
                                            <img src="/assets/img/theme-img/map.svg" alt="" />
                                            FAQ
                                        </Link>
                                        <span>(Help)</span>
                                    </li>
                                    <li>
                                        <Link to="/service">
                                            <img src="/assets/img/theme-img/map.svg" alt="" />
                                            Our Services
                                        </Link>
                                        <span>(Info)</span>
                                    </li>
                                    <li>
                                        <Link to="/tour">
                                            <img src="/assets/img/theme-img/map.svg" alt="" />
                                            Our Tours
                                        </Link>
                                        <span>(Trips)</span>
                                    </li>
                                </ul>
                            </div>
                        </aside>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default TermsConditionsContent

